<template>
    <div>
        <el-card>
            <div slot="header">
                <h3>{{ this.formTitle }}</h3>
            </div>

            <el-form v-if="user" ref="user" :model="user" label-width="300px" label-position="left" :rules="rules">
                <!-- Select Role -->
                <el-form-item v-if="user_is_admin" label="Rolle" prop="role_id">
                    <el-select style="width: 100%" v-model="user.role_id" placeholder="Select User Role">
                        <el-option
                            v-for="role in get_roles"
                            :key="role.id"
                            :label="role.name"
                            :value="role.id"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item v-show="user.role_id && user.role_id !== 1" v-if="user_is_admin" label="Supplier" prop="supplier_id">
                    <el-select style="width: 100%" v-model="user.supplier_id" placeholder="Supplier auswählen" remote default-first-option>
                        <el-option
                            v-for="supplier in get_suppliers"
                            :key="supplier.id"
                            :label="supplier.supplier_name"
                            :value="supplier.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                        label="Name"
                        prop = "name">
                    <el-input
                            v-model="user.name">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="E-mail"
                        prop="email">
                    <el-input
                            v-model="user.email">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Passwort"
                        prop="password">
                    <el-input
                            type="password"
                            v-model="user.password">
                    </el-input>
                </el-form-item>
                <el-form-item
                        label="Passwort wiederholen"
                        prop="repeat_password">
                    <el-input
                            type="password"
                            v-model="user.repeat_password">
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="submitForm('user')">Speichern</el-button>
                    <el-button @click="$emit('close')">Abbrechen</el-button>
                </el-form-item>
            </el-form>
        </el-card>

    </div>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
    import { CREATE_USER, FETCH_SUPPLIERS, FETCH_USERS, UPDATE_USER } from '../../../store/types';
    import responseFormat from '../../../util/responseFormat';

    export default {
        name: 'SupplierForm',
        computed: {
            ...mapGetters(['get_suppliers', 'get_supplier', 'get_users', 'get_user', 'get_current_user', 'user_is_admin', 'get_roles', 'get_role_id', 'get_role_by_id']),
        },
        data () {
            const validatePass = (rule, value, callback) => {
                if (this.formAction === 'create' || value !== '') {
                    if (value === '') {
                        callback(new Error('Passwort wird benötigt'));
                    } else if (value && value.length < 4) {
                        callback(new Error('Password muss 4 Zeichen lang sein'));
                    } else {
                        if (this.user.password !== '') {
                            this.$refs.user.validateField('repeat_password');
                        }
                    }
                }
                callback();
            };
            const validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Bitte Passwort wieder eingeben'));
                } else if (value !== this.user.password) {
                    callback(new Error('Die beiden Eingaben stimmen nicht überein!'));
                } else {
                    callback();
                }
            };
            const validateSupplier = (rule, value, callback) => {
                if (this.user.role_id) {
                    const selectedUserRole = this.get_role_by_id(this.user.role_id);

                    if (selectedUserRole.name !== 'admin') {
                        if (value === '') {
                            callback(new Error('Supplier wird benötigt'));
                        }
                    } else {
                        this.user.supplier_id = null;
                    }
                }

                callback();
            };
            return {
                user: {},
                formTitle: 'Bearbeiten',
                loading: false,
                rules: {
                    role_id: [
                        { required: true, message: 'Rolle wird benötigt', trigger: 'blur' },
                    ],
                    supplier_id: [
                        { required: true, validator: validateSupplier, trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: 'Name wird benötigt', trigger: 'change' },
                    ],
                    email: [
                        { required: true, message: 'E-mail wird benötigt', trigger: 'change' },
                    ],
                    password: [
                        { required: true, validator: validatePass, trigger: 'blur' },
                    ],
                    repeat_password: [
                        { required: true, validator: validatePass2, trigger: 'change' }
                    ],
                },
            };
        },
        props: {
            userId: {
                type: Number
            },
            formAction: {
                required: true,
                type: String,
            },
        },
        created () {
            switch (this.formAction) {
                case 'edit':
                    this.prepareEditForm();
                    break;
                default:
                    this.prepareCreateForm();
            }
        },
        methods: {
            prepareCreateForm () {
                this.formTitle = 'Neue User';
                this.$store.dispatch(FETCH_SUPPLIERS);
            },
            prepareEditForm () {
                if (this.user_is_admin) {
                    this.loading = true;
                    this.$store.dispatch(FETCH_USERS).then(() => {
                        this.$store.dispatch(FETCH_SUPPLIERS);
                        this.user = this.get_user(this.userId);

                        this.loading = false;
                    });
                } else {
                    this.user = this.get_current_user;
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if(this.formAction === 'edit') {
                            // EDIT
                            this.$store.dispatch(UPDATE_USER, this.user).then((resp) => {
                                this.$message.success(resp.message);
                                this.$emit('close');
                            }).catch((resp) => {
                                this.$message.error(responseFormat.getErrorMessage(resp));
                            }).then(() => {
                                this.loading = false;
                            });
                        } else {
                            // CREATE
                            this.$store.dispatch(CREATE_USER, this.user).then((resp) => {
                                this.$message.success(resp.message);
                                this.$emit('close');
                            }).catch((resp) => {
                                this.$message.error(responseFormat.getErrorMessage(resp));
                            }).then(() => {
                                this.loading = false;
                            });
                        }
                    }
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pages/users/UserForm.vue